// extracted by mini-css-extract-plugin
export var formContainer = "_gs-0";
export var message = "_gs-1";